<template>
  <div id="page" :class="{fixed: confirmDialog}">
    <div class="app-content" :class="{show: show}">
      <div class="logo" v-if="feedbackConf.id"><img :src="feedbackConf.logo" alt=""></div>
      <div class="form">
        <div class="divide-title">商户合作</div>
        <div class="wrap">
          <div class="weui-cells">
            <div class="weui-cell">
              <div class="weui-cell__bd"><span class="dot">*</span><span>品牌/公司</span></div>
              <div class="weui-cell__ft">
                <input type="text" v-model="form.companyName" :placeholder="'请输入公司名称'">
              </div>
            </div>
            <div class="weui-cell">
              <div class="weui-cell__bd"><span class="dot">*</span><span>姓名</span></div>
              <div class="weui-cell__ft">
                <input type="text" v-model="form.name" :placeholder="'请输入您的姓名'">
              </div>
            </div>
            <div class="weui-cell">
              <div class="weui-cell__bd"><span>岗位</span></div>
              <div class="weui-cell__ft">
                <input type="text" v-model="form.postName" :placeholder="'请输入所在公司的岗位'">
              </div>
            </div>
            <div class="weui-cell">
              <div class="weui-cell__bd"><span class="dot">*</span><span>联系电话</span></div>
              <div class="weui-cell__ft">
                <input type="text" v-model="form.phone" :placeholder="'请输入您的联系电话'">
              </div>
            </div>
          </div>
        </div>
        <div class="divide-title">商户合作</div>
        <div class="wrap">
          <div class="weui-cells">
            <div class="weui-cell">
              <div class="weui-cell__bd"><span class="dot">*</span><span>合作意向</span></div>
              <div class="weui-cell__ft" @click="onIntentionModal">
                <input type="text" v-model="form.intention" disabled :placeholder="'例如：淘宝店铺的推广'">
              </div>
            </div>
          </div>
        </div>
        <button type="button" class="btn" :style="feedbackConf.id ? {background: feedbackConf.color} : {}" @click="onSubmit">提交</button>
        <!--<div class="tips">
          <h5>请确保您填写的信息正确无误，以免造成损失</h5>
          <p class="text">阿斯达快乐就好静安寺来得及卡利登，奥斯卡登记卡上来的，阿斯卡纶教案设计的</p>
        </div>-->
      </div>
      <transition name="fade">
        <div v-if="showLoading">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast">
          <span class="weui-primary-loading weui-icon_toast">
            <span class="weui-primary-loading__dot"></span>
          </span>
            <p class="weui-toast__content">加载中...</p>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="showToast">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast weui-toast_text">
            <p class="weui-toast__content">{{toastMsg}}</p>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="showSuccToast">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast">
            <i class="weui-icon-success-no-circle weui-icon_toast"></i>
            <p class="weui-toast__content">{{feedbackConf.response_text || '提交成功'}}</p>
          </div>
        </div>
      </transition>
      <div v-if="showDialogIntention">
        <div class="weui-mask"></div>
        <div class="weui-actionsheet" :class="{'weui-actionsheet_show': showScreenDialog}">
          <div class="weui-actionsheet__menu">
            <div class="weui-actionsheet__cell" @click="form.intention = '淘宝店铺推广'; onIntentionCancel()">淘宝店铺推广</div>
            <div class="weui-actionsheet__cell" @click="form.intention = '品牌广告'; onIntentionCancel()">品牌广告</div>
            <div class="weui-actionsheet__cell" @click="form.intention = '线下合作'; onIntentionCancel()">线下合作</div>
            <div class="weui-actionsheet__cell" @click="form.intention = '其他'; onIntentionCancel()">其他</div>
          </div>
          <div class="weui-actionsheet__action">
            <div class="weui-actionsheet__cell" @click="onIntentionCancel">取消</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
#page {
  min-height: 100vh;
}
.app-content {
  height: 100vh;
  overflow-y: auto;
  opacity: 0;
  transition: opacity 0.2s ease;
}
.app-content.show {
  opacity: 1;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0.2s;
}

.weui-actionsheet {
  &.weui-actionsheet_show {
    transform: translate(0,0);
  }
}

.app-content {
  .logo {
    height: 1.38rem;
    text-align: center;
    padding-top: 0.38rem;
    img {
      max-height: 100%;
    }
  }
  .form {
    position: relative;
    padding-top: 0.78rem;
    .wrap {
      background-color: #fff;
      z-index: 9;
      padding: 0 0.26rem;
      box-shadow: 0 3px 10px 0 rgba(0, 0, 0, .025);
      margin-bottom: 0.14rem;
    }
    .divide-title {
      height: 0.76rem;
      line-height: 0.76rem;
      padding-left: 0.28rem;
      font-size: 0.3rem;
      font-weight: 500;
    }
    .weui-cells {
      margin: 0;
      &:after, &:before {
        display: none;
      }
      .weui-cell {
        padding: 12px 0;
        &:before {
          left: 0;
        }
        .weui-cell__bd {
          font-size: 15px;
          width: 2rem;
          flex: none;
          display: flex;
          flex-direction: row;
          align-items: center;
          .dot {
            padding-right: .01rem;
            color: red;
          }
        }
        .weui-cell__ft {
          flex: 1;
        }
        input, span {
          text-align: right;
          border: 0;
          color: #000;
          background-color: #fff;
          font-size: 15px;
          outline:none;
        }
        span {
          float: none;
        }
        input {
          width: 100%;
        }
        input:disabled,
        input[disabled] {
          opacity: 1;
        }
      }
    }
    .btn {
      display: block;
      border: 0;
      background: #fe5069;
      width: 90%;
      margin: 0.4rem auto 0.3rem auto;
      height: 0.78rem;
      border-radius: 0.78rem;
      text-align: center;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      outline: none;
    }
    .tips {
      width: 90%;
      margin: 0 auto;
      h5 {
        font-size: 15px;
        color: #333;
        font-weight: 500;
        text-align: center;
        padding-bottom: 2px;
      }
      .text {
        font-size: 13px;
        color: #666;
      }
    }
  }
}

</style>

<script>
import request from "@/pages/mobile/utils/request";
import moment from 'moment';

export default {
  name: 'home',
  data() {
    return {
      show: false,
      showLoading: true,
      confirmDialog: false,
      showToast: false,
      showSuccToast: false,
      showDialogIntention: false,
      showScreenDialog: false,
      checkUserInfo: false,
      checkAppKey: false,
      disabled: false,
      feedbackConf: {},
      userInfo: {},
      appEnv: {
        prod: true,
        appId: '',
        appKey: '',
      },
      form: {
        companyName: null,
        intention: null,
        name: null,
        postName: null,
        phone: null,
      }
    };
  },
  created() {
    this.appEnv.prod = process.env.VUE_APP_RELEASE === 'prod';
    if (!this.appEnv.prod) {
      this.appEnv.appId = 'CC202104110012172897';
      this.appEnv.appKey = 'EDF0763043A073BC';
      new VConsole();
    }
  },
  mounted() {
    const appId = this.$route.query.appid ||'';
    const appKey = this.$route.query.appkey ||'';
    const uid = this.$route.query.uid || 0;

    if (appId) this.appEnv.appId = appId;
    if (appKey) this.appEnv.appKey = appKey
    if (uid) this.userInfo.id = parseInt(uid, 10);
    if (!this.appEnv.appId || !this.appEnv.appKey) {
      this.showLoading = false;
      this.show = true;
      this.toast('商家存在未配置的参数请联系客服');
      return;
    }
    const h5Userinfo = getH5UserInfo();
    if (h5Userinfo) {
      new Promise(async () => {
        await h5Userinfo.then((resp) => {
          this.checkUserInfo = true;
          this.userInfo = JSON.parse(resp);
        }).catch(() => {});
        let appKey = '';
        this.showLoading = true;
        await checkAppInfo().then(version => {
          appKey = version;
        }).catch((err) => {});
        this.checkAppKey = this.appEnv.appKey === appKey
        this.show = true;
        this.showLoading = false;
        if (!this.checkAppKey) {
          this.toast('商户关联平台不一致请联系客服: ' + this.appEnv.appKey);
          this.disabled = true
        } else  {
          await this.getFeedbackConf(appKey).catch(err => {});
        }
      })
    } else {
      if (!this.appEnv.prod) {
        this.showLoading = true;
        new Promise(async () => {
          await this.getFeedbackConf().catch(err => {});
          this.show = true;
          this.showLoading = false;
        });
      } else {
        this.showLoading = false;
        this.show = true;
        this.toast('未能获取到用户信息请联系客服');
      }
    }
  },
  watch: {
  },
  methods: {
    moment,
    isHuaJuanY() {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.indexOf('huajuanyun') !== -1 || ua.indexOf('html5plus') !== -1 || this.checkUserInfo;
    },
    toast(v, write = true) {
      this.toastMsg = v;
      if (this.isHuaJuanY()) {
        showToast(v);
      } else {
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 2000)
      }
      if (write) {
        request({
          url: `/open/api/analysis/log`,
          method: 'POST',
          data: {uid: this.userInfo.id, appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, nickname: this.userInfo.nickname, msg: v},
        }).then().catch(err => {})
      }
    },
    getFeedbackConf(){
      return request({
        url: `/open/api/feedback-conf`,
        method: 'GET',
        params: {appid: this.appEnv.appId, appkey: this.appEnv.appKey},
      }).then((res) => {
        if (res.id) {
          this.feedbackConf = res
        } else {
          this.disabled = true
          this.toast('未能获取页面配置信息', false)
        }
      }).catch(err => {})
    },
    onIntentionModal() {
      this.showDialogIntention = true;
      setTimeout(() => {
        this.showScreenDialog = true;
      }, 0)
    },
    onIntentionCancel() {
      this.showScreenDialog = false;
      setTimeout(() => {
        this.showDialogIntention = false;
      }, 250)
    },
    onSubmit() {
      if (this.disabled) {
        this.toast('页面配置不正确，请联系客服', false)
        return false
      }
      if (!this.form.companyName || !this.form.name || !this.form.phone || !this.form.intention) {
        this.toast('请填写完整信息', false)
        return
      }
      if (!/^1\d{10}$/.test(this.form.phone)) {
        this.toast('输入的手机号格式不正确')
        return;
      }
      this.showLoading = true;
      const newRequest = request({
        url: '/open/api/feedback',
        method: 'POST',
        data: {
          appid: this.appEnv.appId,
          appkey: this.appEnv.appKey,
          memberId: this.userInfo.id,
          nickname: this.userInfo.nickname,
          avatar: this.userInfo.avatar,
          inviteCode: this.userInfo.invite_code,
          ...this.form
        }
      });
      newRequest.then((resp) => {
        this.showLoading = false;
        this.showSuccToast = true;
        setTimeout(() => {
          this.showSuccToast = false;
          this.form = {
            companyName: null,
            intention: null,
            name: null,
            postName: null,
            phone: null,
          }
        }, 3000)
      }).catch((error) => {
        this.showLoading = false;
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      })
      return newRequest;
    }
  }
}
</script>
